import React, { useState } from 'react';
import styled from 'styled-components';

import Modal from '../Modal/Modal';
import { HealtheraButton } from '../../healtheraComponents';
import Note from './Note';
import AddNoteModal from './AddNoteModal';

const NotesModal = ({ open, notes, onRequestClose, onAddNote, user }) => {
  const [isAddNoteModalOpen, setIsAddNoteModalOpen] = useState(false);

  const toggleIsAddNoteModalOpen = () => {
    setIsAddNoteModalOpen(prevIsAddNoteModalOpen => !prevIsAddNoteModalOpen);
  };

  const handleAddNote = text => {
    setIsAddNoteModalOpen(false);
    onAddNote(text);
  };

  if (isAddNoteModalOpen) {
    return (
      <AddNoteModal
        open
        onRequestClose={toggleIsAddNoteModalOpen}
        onAddNote={handleAddNote}
        user={user}
      />
    );
  }

  return (
    <Modal open={open} onRequestClose={onRequestClose}>
      <Container>
        <NotesContainer>
          {notes.map(note => (
            <NoteWrapper key={note._id}>
              <Note note={note} withPadding />
            </NoteWrapper>
          ))}
        </NotesContainer>
        <ButtonContainer>
          <HealtheraButton height="35px" width="285px" onClick={toggleIsAddNoteModalOpen}>
            Add note
          </HealtheraButton>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
`;

const NotesContainer = styled.div`
  padding: 16px 24px;
  padding-bottom: 60px;
  overflow-y: auto;
  max-height: 650px;
  width: 660px;
`;

const NoteWrapper = styled.div`
  margin-bottom: 16px;
`;

const ButtonContainer = styled.p`
  position: absolute;
  bottom: 4px;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default NotesModal;
